import React, { useEffect, useState } from "react";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";
import BusinessSheetTemplate from "../components/business-sheet/BusinessSheetTemplate";
import { SpinnerPage } from "../components/global/Spinner";
import useLocalStorage from "../hooks/useLocalStorage";
import CopilotLayout from "../components/layout/CopilotLayout";
import CopilotActions from "../components/layout/CopilotActions";
import { useAiSettings } from "../contexts/AiSettingsContext";
import MembershipInfo from "../components/others/MembershipInfo";
import BlockedUsersLink from "../components/others/BlockedUsersLink";
import { createUpdateBusinessSheetData } from "../utils/businessSheetUtils";
import { editBusinessSheetJson } from "../api/businessSheet";

const BusinessSheetWithCopilot = ({
  businessSheetData,
  setBusinessSheetData,
  updateBusinessSheetData,
  updatePortfolioData,
  updateStructuredData,
}) => {
  // Issue #72: AI が有効なときだけ Copilot のフックを呼ぶ
  const { aiEnabled } = useAiSettings();

  return (
    <>
      {aiEnabled && (
        <CopilotActions
          businessSheetData={businessSheetData}
          updateBusinessSheetData={updateBusinessSheetData}
        />
      )}
      <BusinessSheetTemplate
        data={businessSheetData}
        setBusinessSheetData={setBusinessSheetData}
        isEdit={true}
        handleEdit={updateBusinessSheetData}
        handleEditPortfolio={updatePortfolioData}
        handleEditStructured={updateStructuredData}
      />
    </>
  );
};

const Profile = () => {
  const [businessSheetData, setBusinessSheetData] = useState(null);
  const { getValue, setValue } = useLocalStorage();

  useEffect(() => {
    console.log("get sheet");
    setBusinessSheetData(getValue("businessSheetData"));
  }, [getValue]);

  const updateBusinessSheetData = createUpdateBusinessSheetData(
    setBusinessSheetData,
    setValue
  );

  // ポートフォリオ（実績一覧・サービス一覧）は multipart では空配列が消えるため JSON で保存する
  const updatePortfolioData = createUpdateBusinessSheetData(
    setBusinessSheetData,
    setValue,
    editBusinessSheetJson
  );

  // Issue #91: 金のシリーズ／パワーワード／アイテムはネストしたオブジェクト配列のため
  // multipart では構造が化ける。JSON 経路で保存する。
  const updateStructuredData = createUpdateBusinessSheetData(
    setBusinessSheetData,
    setValue,
    editBusinessSheetJson
  );

  return (
    <CopilotLayout
      businessSheetData={businessSheetData}
      updateBusinessSheetData={updateBusinessSheetData}
    >
      <Header />
      <MembershipInfo />
      <BlockedUsersLink />
      {businessSheetData ? (
        <BusinessSheetWithCopilot
          businessSheetData={businessSheetData}
          setBusinessSheetData={setBusinessSheetData}
          updateBusinessSheetData={updateBusinessSheetData}
          updatePortfolioData={updatePortfolioData}
          updateStructuredData={updateStructuredData}
        />
      ) : (
        <SpinnerPage />
      )}
      <Footer />
    </CopilotLayout>
  );
};

export default Profile;